<template>
  <label class="toggle">
    <input
        class="toggle__checkbox"
        type="checkbox"
        v-model="checked"
        v-bind="$attrs"
        @change="onChange"
    />
    <span class="toggle__label toggle__label--off" v-if="labelOff">
      {{ labelOff }}
    </span>
    <span class="toggle__range"></span>
    <span class="toggle__label toggle__label--on" v-if="labelOn">
      {{ labelOn }}
    </span>
  </label>
</template>

<script lang="ts" setup>
interface ToggleProps {
  modelValue: boolean;
  labelOff?: string;
  labelOn?: string;
}

const props = withDefaults(defineProps<ToggleProps>(), { labelOff: '', labelOn: '' });

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'change', value: boolean): void;
}>();

const checked = ref(props.modelValue);

watch(
    () => props.modelValue,
    (newValue: boolean) => {
      checked.value = newValue;
    },
    { immediate: true }
);

const onChange = () => {
  emit('update:modelValue', checked.value);
  emit('change', checked.value);
};
</script>

<style lang="scss" scoped>
@use "VToggle";
</style>
